import {
  ArrowRightCircleIcon,
  BuildingStorefrontIcon,
  QuestionMarkCircleIcon,
  UserPlusIcon
} from '@heroicons/vue/24/outline'
import { computed } from 'vue'

import { usePresentationTranslator } from '~/composables/usePresentationTranslator'

/** Guest navigation entries in display order for each audience. */
export function useNavigationSolutions(audience: 'customers' | 'restaurants') {
  const t = usePresentationTranslator()

  return computed(() => [
    {
      name: t('common.actions.signUp'),
      href: audience === 'restaurants' ? '/join' : '/register',
      icon: UserPlusIcon
    },
    { name: t('common.actions.signIn'), href: '/login', icon: ArrowRightCircleIcon },
    ...(audience === 'restaurants'
      ? [
          {
            name: t('common.navigation.freeListing'),
            href: '/partners',
            icon: BuildingStorefrontIcon
          }
        ]
      : []),
    { name: t('common.navigation.helpSupport'), href: '/contact', icon: QuestionMarkCircleIcon }
  ])
}
